import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles';
import {
  selectUserAttributes,
  selectBusinessAttributes,
} from '../../../store/selectors';
import formFields from './BuilderProfilePersonalForm/formFields';
import { validateEmailUnique } from '../../../utilities/validators';
import BuilderProfilePersonalForm from './BuilderProfilePersonalForm';
import { preparePhoneNumberForFrontend } from '../../../utilities/helpers';
import { SERVICE_AREAS } from '../../../constants';

const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.shape({
    'custom:buildingLicNo': PropTypes.string,
    'custom:buildingLicExp': PropTypes.string,
    'custom:businessAddress': PropTypes.string,
    'custom:businessName': PropTypes.string,
    'custom:personalEmail': PropTypes.string,
    'custom:personalPhone': PropTypes.string,
    'custom:position': PropTypes.string,
    'custom:profileHeadline': PropTypes.string,
    'custom:serviceAState': PropTypes.string,
    'custom:serviceAType': PropTypes.string,
    'custom:skillsetBuild': PropTypes.string,
    'custom:skillsetLook': PropTypes.string,
    email: PropTypes.string,
    email_verified: PropTypes.string,
    name: PropTypes.string,
    sub: PropTypes.string,
  }).isRequired,
  businessAttributes: PropTypes.shape({
    businessNumber: PropTypes.string,
    businessName: PropTypes.string,
    businessMailingAddress: PropTypes.string,
    businessDescription: PropTypes.string,
    businessPhoneNumber: PropTypes.string,
    businessServiceAreaAddress: PropTypes.string,
    businessServiceAreaCoordinates: PropTypes.string,
    businessSkillsetBuild: PropTypes.string,
    businessSkillsetLook: PropTypes.string,
    businessPosition: PropTypes.string,
    businessApproved: PropTypes.int,
    businessServiceAreaState: PropTypes.string,
    businessServiceAreaType: PropTypes.oneOf([
      SERVICE_AREAS.LOCAL,
      SERVICE_AREAS.NATIONAL,
      SERVICE_AREAS.STATEWIDE,
    ]),
  }).isRequired,
  enableEditing: PropTypes.bool.isRequired,
};

export const BuilderProfilePersonalContainer = props => {
  const { classes, userAttributes, enableEditing, businessAttributes } = props;
  const [initialDate, setInitialDate] = useState('');
  const [builderExpDate, setBuilderExpDate] = useState('');

  useEffect(() => {
    const datePicker = document.querySelector(
      '#building-licence-expiry-text-field',
    );
    if (datePicker) {
      enableDatePicker(datePicker);
    }
  });

  // Enable date selector
  const enableDatePicker = async datePicker => {
    const options = {
      dateFormat: 'd-m-Y',
      minDate: 'today',
      disableMobile: true,
      onChange: () => {
        handleDateChange(flatpicker);
      },
    };
    const flatpicker = await flatpickr(datePicker, options);
  };

  const handleDateChange = flatpicker => {
    const [selectedDate] = flatpicker.selectedDates;
    const isoDate = selectedDate.toISOString();

    const formValue = moment(isoDate).format('DD-MM-YYYY');
    setInitialDate(formValue);
  };

  useEffect(() => {
    if (userAttributes['custom:buildingLicExp']) {
      setInitialDate(
        moment(userAttributes['custom:buildingLicExp']).format('DD-MM-YYYY'),
      );
      setBuilderExpDate(
        moment(userAttributes['custom:buildingLicExp']).format('DD-MM-YYYY'),
      );
    }
  }, [userAttributes]);

  const handleAsyncValidate = values =>
    validateEmailUnique('custom:personalEmail', values, userAttributes.email);

  // console.log({ userAttributes });
  const getInitialFormValues = () => {
    const initialValues = {
      sub: userAttributes.sub,
    };

    formFields.forEach(field => {
      if (userAttributes[field.name]) {
        if (field.name === 'custom:personalPhone') {
          initialValues['custom:personalPhone'] = preparePhoneNumberForFrontend(
            userAttributes['custom:personalPhone'],
          );
        } else if (
          field.name === 'custom:mobileNumber' &&
          userAttributes['custom:mobileNumber']
        ) {
          initialValues['custom:mobileNumber'] = preparePhoneNumberForFrontend(
            userAttributes['custom:mobileNumber'],
          );
        } else if (field.name === 'custom:buildingLicExp') {
          if (userAttributes['custom:buildingLicExp']) {
            initialValues['custom:buildingLicExp'] = initialDate;
          }
        } else {
          initialValues[field.name] = userAttributes[field.name];
        }
      } else if (userAttributes[field.name] === undefined) {
        initialValues[field.name] = businessAttributes[field.name] || '';
      } else if (field.name === 'deactivate') {
        if (userAttributes.approved === 2) {
          initialValues.deactivate = true;
        }
      } else {
        initialValues[field.name] = '';
      }
    });
    return initialValues;
  };

  return (
    <Card className={classes.cardRoot}>
      <CardContent>
        <h2 className={classes.heading}>{userAttributes.name}</h2>
        <BuilderProfilePersonalForm
          initialValues={getInitialFormValues()}
          builderExpDate={builderExpDate}
          enableReinitialize
          enableEditing={enableEditing}
          asyncValidate={handleAsyncValidate}
        />
      </CardContent>
    </Card>
  );
};

BuilderProfilePersonalContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  userAttributes: selectUserAttributes(),
  businessAttributes: selectBusinessAttributes(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(BuilderProfilePersonalContainer),
);
